import { useEffect } from 'react';

import { useMountedRef } from '@utils/hooks/mount';

/** Almost the same as useEffect, but will skip the initial effect run on mount */
export function useEffectAfterMount(cb: () => void, deps?: any[]) {
  useEffect(() => {
    if (mountedRef.current) return cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  const mountedRef = useMountedRef();
}
